import { Flex, Icon, Link } from '@chakra-ui/react';
import React from 'react';
import { NavLink } from 'react-router-dom';

const NavItem = props => {
  const { icon, children, to, isExternal = false, ...rest } = props;
  if (isExternal) {
    return (
      <Link href={to} _hover={{ textDecoration: 'none' }} isExternal>
        <Flex
          align="center"
          px="7"
          mb={2}
          borderRadius="1rem"
          py="4"
          cursor="pointer"
          _hover={{
            bg: 'primaryOpaque',
            color: 'primary',
          }}
          role="group"
          fontWeight="semibold"
          transition=".15s ease"
          bg={'transparent'}
          color={'black'}
          {...rest}
        >
          {icon && (
            <Icon
              mr="2"
              boxSize="5"
              color={'lightGray.500'}
              _groupHover={{
                color: 'primary',
              }}
              as={icon}
            />
          )}
          {children}
        </Flex>
      </Link>
    );
  }
  return (
    <Link as={NavLink} to={to} _hover={{ textDecoration: 'none' }} end>
      {({ isActive }) => (
        <Flex
          align="center"
          px="7"
          mb={2}
          borderRadius="1rem"
          py="4"
          cursor="pointer"
          _hover={
            !isActive && {
              bg: 'primaryOpaque',
              color: 'primary',
            }
          }
          role="group"
          fontWeight="semibold"
          transition=".15s ease"
          bg={isActive ? 'primary' : 'transparent'}
          color={isActive ? 'white' : 'black'}
          {...rest}
        >
          {icon && (
            <Icon
              mr="2"
              boxSize="5"
              color={isActive ? 'white' : 'lightGray.500'}
              _groupHover={
                !isActive && {
                  color: 'primary',
                }
              }
              as={icon}
            />
          )}
          {children}
        </Flex>
      )}
    </Link>
  );
};

export default NavItem;
